<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="card card-wizard" id="wizardCard" :key="$store.state.registration_wizardKey">
          <form-wizard ref="wizard"
                       @on-complete="wizardComplete"
                       @on-change="scrollToTop"
                       error-color="#31bebf"
                       :title="title"
                       :start-index="$store.state.registration_tab_index"
                       :subtitle="chineseFields && spanishFields ? translatedFields['patient_registration_form'] : ''"
                       color='#31bebf'>

            <tab-content :title="translatedFields['site']"
                         :before-change="validateFirstStep"
                         route="/patient/register/site-selection"
                         icon="ti-user">
              <first-step ref="firstStep"
                          v-on:jumpToTheNextPage="jumpToTheNextPage">
              </first-step>
            </tab-content>

            <tab-content v-if="allowDisclaimer"
                         :title="translatedFields['disclaimer']"
                         :before-change="validateSecondStep"
                         route="/patient/register/disclaimer"
                         icon="ti-settings">
              <second-step ref="secondStep"
                           v-on:nextTab="nextTab">
              </second-step>
            </tab-content>

            <tab-content v-if="allowConsent"
                         :title="translatedFields['consent']"
                         :before-change="validateThirdStep"
                         route="/patient/register/consent"
                         icon="ti-settings">
              <third-step ref="thirdStep"
                          v-on:nextTab="nextTab">
              </third-step>
            </tab-content>

            <tab-content :title="translatedFields['medical_data']"
                         :before-change="validateForthStep"
                         route="/patient/register/medical-data"
                         icon="ti-settings">
              <forth-step ref="forthStep"
                          v-on:nextTab="nextTab"
              ></forth-step>
            </tab-content>

            <tab-content v-if="allowInsurance"
                         :title="translatedFields['insurance_information']"
                         :before-change="validateFifthStep"
                         route="/patient/register/insurance"
                         icon="ti-settings">
              <fifth-step ref="fifthStep"
                          v-on:nextTab="nextTab"
              ></fifth-step>
            </tab-content>

            <tab-content v-if="allow_telehealth"
                         :title="translatedFields['submission']"
                         :before-change="validateSixthStep"
                         route="/patient/register/telehealth"
                         icon="ti-check">
              <sixth-step ref="sixthStep"
                          v-on:nextTab="nextTab"
              ></sixth-step>
            </tab-content>

            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back"><span>{{ translatedFields['back'] }} </span></button>
            <button slot="next" class="btn btn-fill btn-wd btn-next"><span> {{ translatedFields['next'] }}</span></button>
            <button slot="finish" :disabled="disabled" class="btn btn-info btn-fill btn-wd btn-submit"><span>  {{ translatedFields['i_agree_and_submit'] }} </span></button>
          
          </form-wizard>

          <div class="row">
            <div class="col-md-12">
              <p v-if="allow_results" class="m-50">{{ translatedFields['check_your_results'] }}
                <router-link to="/patient/check-results" class="htrx-primary">{{ translatedFields['here'] }}</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import FirstStep from './Wizard/SiteSelectionStep.vue'
  import SecondStep from './Wizard/DisclaimerStep.vue'
  import ThirdStep from './Wizard/ConsentStep.vue'
  import ForthStep from './Wizard/MedicationDataStep.vue'
  import FifthStep from './Wizard/InsuranceStep.vue'
  import SixthStep from './Wizard/SubmissionStep.vue'
  import swal from 'sweetalert2'
  import axios from 'axios'

  export default {
    data () {
      return {
        saveRegistrationCompleted: false,
        translatedFields: '',
        fields_en: {
          next: 'Next',
          back: 'Back',
          i_agree_and_submit: 'I Agree and Submit',
          patient_registration_form: 'Patient Registration Form',
          site: 'Site',
          medical_data: 'Medical Data',
          disclaimer: 'Disclaimer',
          insurance_information: 'Insurance Information',
          submission: 'Submission',
          check_your_results: 'Check your results',
          here: 'here',
          consent: 'Consent'
        },
        allow_results: String(process.env.ALLOW_RESULTS) === 'true',
        allow_telehealth: String(process.env.ALLOW_TELEHEALTH) === 'true',
        disabled: false,
        title: process.env.LAB_NAME,
        wizardModel: {}
      }
    },
    components: {
      FirstStep,
      SecondStep,
      ThirdStep,
      ForthStep,
      FifthStep,
      SixthStep
    },
    mounted: function () {
      this.$sidebar.isMinimized = true
    },
    methods: {
      nextTab () {
        this.$refs.wizard.nextTab()
      },
      jumpToTheNextPage () {
        // this method will jump to the next page without any validation
        // do not use it
        this.$refs.wizard.changeTab(0, 1)
      },
      checkLanguage () {
        if (this.$store.state.lang.value === 'ES') {
          this.translatedFields = this.$store.state.translation_es
        } else {
          if (this.$store.state.lang.value === 'ZH') {
            this.translatedFields = this.$store.state.translation_zh
          } else {
            this.translatedFields = this.fields_en
          }
        }
      },
      saveRegistration (data) {
        data.firstName = data.firstName.trim()
        data.lastName = data.lastName.trim()
        data.phone = data.phone.replace(/[- )(]/g, '')
        this.translatedFields['i_agree_and_submit'] = 'Submitting.. Please wait'
        const self = this
        axios.post(process.env.SERVER_URI + '/register/' + this.$store.state.site.code, data)
        .then((response) => {
          if (response.data === false) {
            swal('Error!', 'There was an error submitting the data', 'error')
            self.redirect()
          } else {
            swal('Completed!', 'Your registration has been received.<br>Please check your email for your confirmation number', 'success')
            .then(function (result) {
              window.location.reload()
            })
            .catch(swal.noop)
            self.redirect()
          }
        }).catch(error => {
          if (error.response.status === 429) {
            swal('Error!', 'It looks like you already registered! Please check your email for the confirmation number or try again later', 'error')
            .then(function (result) {
              window.location.reload()
            })
            .catch(swal.noop)
            self.redirect()
          } else {
            swal('Error!', 'There was an error submitting the data', 'error')
            .then(function (result) {
              window.location.reload()
            })
            self.redirect()
          }
        })
      },
      redirect () {
        const body = document.querySelector('body')
        body.onclick = function () {
          window.location.reload()
        }
      },
      validateStep (step, index) {
        let stepValidation = step.validate()
        if (stepValidation && this.$store.state.registration_tab_index < 2) {
          this.$store.state.registration_tab_index = index
        }
        return stepValidation
      },
      validateFirstStep () {
        return this.validateStep(this.$refs.firstStep, 1)
      },
      validateSecondStep () {
        return this.validateStep(this.$refs.secondStep, 2)
      },
      validateThirdStep () {
        return this.validateStep(this.$refs.thirdStep, 3)
      },
      validateForthStep () {
        return this.validateStep(this.$refs.forthStep, 4)
      },
      validateFifthStep () {
        return this.validateStep(this.$refs.fifthStep, 5)
      },
      validateSixthStep () {
        return this.validateStep(this.$refs.sixthStep, 6)
      },
      wizardComplete: function () {
        this.disabled = true
        // we gather models from all steps into one model
        if (!this.saveRegistrationCompleted) {
          Object.assign(this.wizardModel, this.$refs.firstStep.model)
          if (this.allowDisclaimer) {
            Object.assign(this.wizardModel, this.$refs.secondStep.model)
          }
          if (this.allowConsent) {
            Object.assign(this.wizardModel, this.$refs.thirdStep.model)
          }
          Object.assign(this.wizardModel, this.$refs.forthStep.model)
          if (this.allowInsurance) {
            Object.assign(this.wizardModel, this.$refs.fifthStep.model)
          }
          if (this.allow_telehealth) {
            Object.assign(this.wizardModel, this.$refs.sixthStep.model)
          }
          this.wizardModel.questions = this.$store.state.questions
          this.saveRegistrationCompleted = true
          this.saveRegistration(this.wizardModel)
        }
      },
      scrollToTop () {
        let elmnt = document.getElementsByClassName('main-panel')[0]
        elmnt.scrollTo(0, 0)
      }
    },
    computed: {
      language () {
        this.checkLanguage()
        return this.$store.state.lang.value
      },
      spanishFields () {
        return this.$store.state.translation_es
      },
      chineseFields () {
        return this.$store.state.translation_zh
      },
      allowDisclaimer () {
        return this.$store.state.allow_disclaimer ? this.$store.state.allow_disclaimer : (String(process.env.ALLOW_DISCLAIMER) === 'true')
      },
      allowInsurance () {
        return this.$store.state.allow_insurance ? this.$store.state.allow_insurance : (String(process.env.ALLOW_INSURANCE) === 'true')
      },
      allowConsent () {
        return this.$store.state.allow_consent ? this.$store.state.allow_consent : (String(process.env.ALLOW_CONSENT) === 'true')
      }
    },
    watch: {
      language () {
        this.checkLanguage()
      }
    },
    beforeMount () {
      this.$store.commit('resetPatientRegistrationSettings')
    },
    beforeDestroy () {
      this.$store.commit('resetPatientRegistrationSettings')
    }
  }
</script>
<style scoped>
  .htrx-primary{
    color:#31bebf;
  }

  >>> .vue-form-wizard .wizard-icon-circle {
    background-color: white;
    color: #323737;
    border: 3px solid #323737;
  }

  >>> .vue-form-wizard .wizard-nav-pills>li>a {
    color: #323737;
  }


  >>> div[aria-selected="true"]{
    background-color: #31bebf !important;
  }

  span button {
    transition: 0.5s;
  }

  .btn-next {
    background-color: white !important;
    color: #323737 !important;
    min-height: 40px;
    border: 2px solid #31bebf !important;
    border-radius: 20px;
  }

  .btn-next:hover{
    border: none;
    background-color: #31bebf !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-next:focus{
    border: none !important;
    background-color: #31bebf !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-next span:after {
    content: '\00bb';
    opacity: 1;
    font-size: 17px;
    margin-left: 5px;
  }

  .btn-back{
    background-color: transparent !important;
    color: #f4c617 !important;
    min-height: 40px;
    border: none;
    border-radius: 20px;
  }

  .btn-back span:before {
    content: '\00AB';
    opacity: 1;
    font-size: 17px;
    margin-right: 5px;
  }

  .btn-back:hover{
    border: none !important;
    background-color: #f4c617 !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-back:focus{
    border: none !important;
    background-color: #f4c617 !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-submit{
    background-color: white !important;
    color:  #323737 !important;
    min-height: 40px;
    border: 2px solid #31bebf !important;
    border-radius: 20px;
  }

  .btn-submit:hover{
    border: none;
    background-color: #31bebf !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-submit:focus{
    border: none;
    background-color: #31bebf !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-submit span:after {
    content: '\2713';
    opacity: 1;
    font-size: 17px;
    margin-left: 5px;
  }

  .m-50{
    margin-top: 20px;
    padding-bottom: 20px;
    margin-left: 20px;
  }

  @media (max-width: 400px) {
    >>> .vue-form-wizard .wizard-card-footer {
      display: -webkit-box;
      display: -moz-box;
      display: box;

      -webkit-box-orient: vertical;
      -moz-box-orient: vertical;
      box-orient: vertical;
    }

    >>> .vue-form-wizard .wizard-card-footer .wizard-footer-right {
      position: relative;
      min-height: 1px;
      width: 100%;
      margin-top: 10px;

      -webkit-box-ordinal-group: 1;
      -moz-box-ordinal-group: 1;
      box-ordinal-group: 1;
    }

    >>> .vue-form-wizard .wizard-card-footer .wizard-footer-left {
      position: relative;
      min-height: 1px;
      width: 100%;

      -webkit-box-ordinal-group: 2;
      -moz-box-ordinal-group: 2;
      box-ordinal-group: 2;
    }

    .btn-back{
      width: 100%;
    }

    .btn-next{
      width: 100%;
    }

    .btn-submit{
      width: 100%;
    }

    >>> span[role=button] {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Patient/RegistrationWizard.vue